import { Helper } from '../Helper';
export class FunctionHelper extends Helper {
    constructor({ body }) {
        super();
        this.body = body;
    }
    emit(sb, node, options) {
        if (options.pushValue) {
            const jump = sb.jumpTable.add(sb, node, () => {
                const innerOptions = { superClass: options.superClass };
                this.body(innerOptions);
            });
            sb.emitPushInt(node, jump);
        }
    }
}

//# sourceMappingURL=FunctionHelper.js.map
